import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('bb_token');
    if (token) {
      api.get('/auth/me')
        .then(r => setUser(r.data))
        .catch(() => localStorage.removeItem('bb_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('bb_token', data.access_token);
    localStorage.setItem('bb_refresh_token', data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('bb_token');
    localStorage.removeItem('bb_refresh_token');
    setUser(null);
  };

  const updateUser = (patch) => setUser(u => (u ? { ...u, ...patch } : u));

  // Recipient → donor upgrade. Lives here because every caller needs the new
  // role reflected in context immediately (navbar tabs, route guards) — the
  // role is read from the DB server-side, so no re-login is involved.
  const becomeDonor = async () => {
    const { data } = await api.post('/auth/me/become-donor');
    setUser(data);
    return data;
  };

  const refreshUser = async () => {
    if (!localStorage.getItem('bb_token')) return;
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch { /* stale/invalid session — leave as-is, api interceptor handles 401 */ }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser, refreshUser, becomeDonor }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
